import { PAGE_CODE_TEMPLATE } from './constants.js';
import { getBackendFolder, getPagesFolder, getPublicFolder, getStylesFolder } from '@wix/velo-github-layout-definitions';
import { foldersType } from '../../types.js';
export const createDefaultPageCodeFile = async (siteFileSystem, filePath) => siteFileSystem.writeFile(filePath, PAGE_CODE_TEMPLATE);
export const getPageCodeFilePath = (pageId) => `${getPagesFolder()}/${pageId}.js`;
export const convertToGithubLayout = (state, path, folderType) => {
    switch (folderType) {
        case foldersType.backend:
            return transformPath(path, state.fileStructure.getBackendFolderPath(), getBackendFolder());
        case foldersType.public:
            return transformPath(path, state.fileStructure.getPublicFolderPath(), getPublicFolder());
        case foldersType.styles:
            return transformPath(path, state.fileStructure.getStylesFolderPath(), getStylesFolder());
    }
};
const transformPath = (path, basePath, folderPrefix) => {
    const relativePath = path.replace(`${basePath}/`, '');
    return `${folderPrefix}/${relativePath}`;
};
